<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
<div id="page-user-edit">
  <div style="background:white; box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 10%); border-radius:8px">
    <div slot="no-body" class="tabs-container px-6 pt-6">
      <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
        <vs-tab label="시험정보" icon-pack="feather" icon="icon-info">
          <div class="tab-text">
            <exam-edit-tab-information class="mt-4" @save="moveTo()" />
          </div>
        </vs-tab>
        <vs-tab label="과목" icon-pack="feather" icon="icon-info" v-show="activeExam.id != 0">
          <div class="tab-text vx-row">
            <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
              <vx-card class="text-center" style="height:180px;">
                <div class="p-6 text-center">
                  <div class="vx-row justify-center">
                    <vs-button color="dark" type="border" icon-pack="feather" icon="icon-plus" size="small" @click="activePrompt = true" style="margin-top:20px; margin-right:10px;" />
                    <p class="text" style="margin-top:22px;" @click="activePrompt = true"> 과목 추가 </p>
                  </div>
                </div>
              </vx-card>
            </div>
            <SubjectItem v-if="subjectCode.length" v-for="(subject, index) in subjectList" :subjectInfo="subject" v-bind:key="index" />
            <!-- <user-edit-tab-social class="mt-4" :data="user_data" /> -->
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>

  <vs-prompt class="email-compose" title="시험 과목 추가" accept-text="업로드" cancel-text="취소" @cancel="clearFields" @close="clearFields" @accept="createSubmit" :active.sync="activePrompt">
    <!-- <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl"> -->
    <form @submit.prevent>
      <vs-input class="w-full mt-4" label="과목 이름" v-model="subject_data.subject" />
      <vs-select label="과목 정보" v-model="selectSubjectType" class="w-full mt-5">
          <vs-select-item :key="subject.id" :value="subject" :text="subject.name" v-for="subject in subjectType" />
      </vs-select>
      <vs-select label="디테일 정보" v-model="selectSubjectDetailType" class="w-full mt-5">
          <vs-select-item :key="subject.id" :value="subject.subject_code" :text="subject.subject_detail_name" v-for="subject in detailType" />
      </vs-select>
      <vs-input class="w-full mt-4" label="추가 정보" v-model="subject_data.detail" />
      <vs-input class="w-full mt-4" label="시험 시간 (분단위)" v-model="subject_data.time_limit" />
      <vs-input class="w-full mt-4" label="총 점수" v-model="subject_data.total_score" />
      <vs-input class="w-full mt-4" label="총 문제수" v-model="subject_data.total_question" />
    </form>
    <!-- </component> -->
  </vs-prompt>
</div>
</template>

<script>
import ExamEditTabInformation from "./ExamEditTabInformation.vue"
import SubjectItem from "./SubjectItem.vue"
// Store Module
import moduleETest from '@/store/etest/moduleETest.js'

export default {
  components: {
    ExamEditTabInformation,
    'SubjectItem': SubjectItem,
  },
  data() {
    return {
      subject_data: {
        "detail": "",
        "exam_id": null,
        "subject": "",
        "subject_state": 0,
        "subject_type_id": null,
        "time_limit": 60,
        "total_question": 0,
        "total_score": 100,
        "subject_code" : ""
      },
      selectSubjectType: {},
      activePrompt: false,
      detailType: {},
      selectSubjectDetailType: '',
      activeTab: 0,
    }
  },

  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    subjectList() {
      return this.$store.state.etest.subjectList
    },
    activeExam() {
      return this.$store.state.etest.activeExam
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser
    },
    subjectType() {
      return this.$store.state.etest.subjectType
    },
    subjectCode(){
      return this.$store.state.etest.subjectCode
    },
  },
  watch: {
    selectSubjectType(){
        this.initSubject()
        console.log(this.selectSubjectType)
    },
    activeTab() {}
  },
  methods: {
    initSubject() {
      var list = this.subjectCode.filter((item)=> {
          return item.grade == this.activeExam.grade_id
        })
        this.detailType = list.filter((item)=> {
          return item.subject_type_id == this.selectSubjectType.id
        })
    },
    moveTo() {
      this.activeTab = 1
    },
    clearFields() {

    },
    createSubmit() {
      this.subject_data.exam_id = this.$store.state.etest.activeExam.id
      this.subject_data.subject_type_id = this.selectSubjectType.id
      this.subject_data.subject_code = this.selectSubjectDetailType
      // this.subject_data.subject_code = this.selectSubjectDetailType
      this.$store.dispatch('etest/createEtestSubject', this.subject_data)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: '완료',
            text: this.subject_data.subject + '을 생성하였습니다.'
          })
          this.$emit('save')
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    }
  },
  mounted(){
    this.$store.dispatch('etest/getSubjectType')
    this.$store.dispatch('etest/getSubjectCodeInfo')

  },
  created() {
    // Register Module UserManagement Module
    if (!moduleETest.isRegistered) {
      this.$store.registerModule('eTest', moduleETest)
      moduleETest.isRegistered = true
    }
    this.activeTab = this.$route.params.activeId
    if (this.$store.state.etest.activeExam.defect && this.AppActiveUser.userRole == 'admin') {
      this.$store.dispatch('etest/getDefectEtestSubject', this.$store.state.etest.activeExam.id)
      return
    }
    if (this.$store.state.etest.activeExam.id) {
      this.$store.dispatch('etest/getEtestSubject', this.$store.state.etest.activeExam.id).then(()=>{
        this.initSubject()
      })
    }
  }
}
</script>


<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 705px;
        }
    }
}
</style>
